{
    "Accessibility Menu": "Tilgjengelighetsmeny",
    "Reset settings": "Tilbakestill innstillinger",
    "Close": "Lukk",
    "Content Adjustments": "Innholdstilpasninger",
    "Adjust Font Size": "Juster skriftstørrelse",
    "Highlight Title": "Fremhev tittel",
    "Highlight Links": "Fremhev lenker",
    "Readable Font": "Lesbar skrifttype",
    "Color Adjustments": "Fargejusteringer",
    "Dark Contrast": "Mørk kontrast",
    "Light Contrast": "Lys kontrast",
    "High Contrast": "Høy kontrast",
    "High Saturation": "Høy metning",
    "Low Saturation": "Lav metning",
    "Monochrome": "Monokrom",
    "Protanopia": "Protanopi",
    "Deuteranopia": "Deuteranopi",
    "Tritanopia": "Tritanopi",
    "Visual & Navigation Aids": "Visuelle og navigasjonshjelpemidler",
    "Additional Tools": "Tilleggsverktøy",
    "Reading Guide": "Leseguide",
    "Stop Animations": "Stopp animasjoner",
    "Big Cursor": "Stor peker",
    "Screen Reader": "Skjermleser",
    "Hide Images": "Skjul bilder",
    "Image Tooltips": "Bildeforklaringer",
    "Page Structure": "Sidestruktur",
    "Super Focus": "Superfokus",
    "Magnifier": "Forstørrelsesglass",
    "Increase Font Size": "Øk skriftstørrelsen",
    "Decrease Font Size": "Reduser skriftstørrelsen",
    "Letter Spacing": "Bokstavavstand",
    "Line Height": "Linjehøyde",
    "Font Weight": "Skriftvekt",
    "Dyslexia Font": "Dysleksisk skrifttype",
    "Language": "Språk",
    "Open Accessibility Menu": "Åpne tilgjengelighetsmeny",
    "Accessibility Profiles": "Tilgjengelighetsprofiler",
    "Seizure Safe Profile": "Anfallssikker profil",
    "Stops animations and reduces color saturation.": "Stopper animasjoner og reduserer fargemetning.",
    "Blind Profile": "Profil for blinde",
    "Activates the screen reader for auditory navigation.": "Aktiverer skjermleseren for auditiv navigasjon.",
    "Visually Impaired Profile": "Profil for svaksynte",
    "Enhances contrast and readability for low vision.": "Forbedrer kontrast og lesbarhet for svaksynte.",
    "ADHD Friendly Profile": "ADHD-vennlig profil",
    "Reduces distractions for better focus.": "Reduserer distraksjoner for bedre konsentrasjon.",
    "Cognitive & Learning Profile": "Kognitiv og lærings-profil",
    "Helpful tools for reading and comprehension.": "Nyttige verktøy for lesing og forståelse.",
    "Motor Impaired Profile": "Motorisk nedsatt profil",
    "Optimizes the site for keyboard-only navigation.": "Optimaliserer nettstedet for navigasjon kun med tastatur.",
    "Headings": "Overskrifter",
    "Landmarks": "Landemerker",
    "Links": "Lenker",
    "Focus element": "Fokuser element",
    "Visit link": "Besøk lenke"
}
